import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Card, CardActions, CardContent, CardMedia, Chip, Grid, Stack, Typography, Tooltip, IconButton, Tab, Link } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PlaylistAddSong from './PlaylistAddSong';
import ApiService from '../../../../_services/ApiService';
import playlist from '../../../../img/default-image.png'
import GetMoodGenreLanguage from '../../../../_helpers/reusablefunctions/getMoodGenreLanguage';
import { getStrPlatformImg } from '../../../../_helpers/reusablefunctions/getStreamingPlatform';
import SkeletonCard from '../../../../_helpers/reusablefunctions/SkeletonCard';
import MusicNoteIcon from '@mui/icons-material/MusicNote';      // For Genre
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions'; // For Mood
import LanguageIcon from '@mui/icons-material/Language';        // For Language
import { useParams } from 'react-router-dom';

export default function OfficialPlaylistDetail() {
    const location = useLocation();
    const history = useHistory();
    const {playlistId} = useParams();
    const ref = useRef();
    // const playlistData = location?.state?.playlistData
    const [playlistData, setPlaylistData] = useState([]);
    const [playlistSongLibrary, setPlaylistSongLibrary] = useState([])
    const [loader, setLoader] = useState({
        song: true,
    })

    const handleRouteBack = () => {
        history.push('/discover-playlist')
    }

    function getSingleSong() {
        setLoader(prev => ({ ...prev, song: true }))
        ApiService.get('getSinglePlaylist', { playlist_id: playlistId }).then(res => {
            setLoader(prev => ({ ...prev, song: false }))
            if (res.status === 200 || res.status === 201) {
                setPlaylistData(res.data.data[0])
                setPlaylistSongLibrary(res.data.data[0].playlist_releated_platform)
            }
        }).catch(error => {
            setLoader(prev => ({ ...prev, song: false }))
            console.log(error)
        })
    }
    useEffect(() => {
        getSingleSong()
    }, [])

    return (
        <Box sx={{ padding: '1rem 1rem 3rem 1rem' }}>
            <Box alignItems={'center'} display={'flex'} justifyContent={'space-between'} >
                <Button className='gap-3 text-black' onClick={handleRouteBack}><ArrowBackIcon /> {playlistData?.playlist_name}</Button>
            </Box>
            <Box mt={2} mb={4}>
                <Grid container spacing={2} paddingLeft={2} paddingRight={2}>
                    <Grid item xs={12} md={4} lg={4} >
                        <Card
                            sx={{
                                backgroundColor: '#F14950',
                                color: 'white',
                                borderRadius: '12px',
                                overflow: 'hidden'
                            }}
                        >
                            <Box display="flex" p={2}>
                                <CardMedia
                                    component="img"
                                    sx={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: '8px',
                                        marginRight: 2
                                    }}
                                    image={
                                        playlistData?.playlist_cover_image_url
                                            ? playlistData.playlist_cover_image_url
                                            : playlistData?.playlist_cover_image
                                                ? process.env.REACT_APP_BASEURL_MEDIA + '/media/' + playlistData.playlist_cover_image
                                                : playlist
                                    }
                                />
                                <Box flex={1}>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                        {playlistData?.playlist_name || 'Unknown Playlist'}
                                    </Typography>
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <Typography variant="body2">
                                            By: {playlistData?.user_name || 'GNTunes'}
                                        </Typography>
                                    </Box>

                                    {playlistData?.playlist_genre?.length ? <GetMoodGenreLanguage icon={<MusicNoteIcon sx={{fontSize:'20px'}} />} sliceCount={1} label="" items={playlistData?.playlist_genre || []} /> : null}
                                    {playlistData?.mood?.length ? <GetMoodGenreLanguage icon={<EmojiEmotionsIcon sx={{fontSize:'20px'}} />} sliceCount={1} label="" items={playlistData?.mood || []} /> : null}
                                    {playlistData?.language?.length ? <GetMoodGenreLanguage icon={<LanguageIcon sx={{fontSize:'20px'}} />} sliceCount={1} label="" items={playlistData?.language || []} /> : null}


                                </Box>
                            </Box>
                        </Card>
                        {/* Click to play section */}
                        {playlistSongLibrary.length > 0 && <Typography variant="h6" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>
                            Listen Songs
                        </Typography>}

                        <Stack spacing={1}>
                            {loader.song ? (
                                Array.from(new Array(6)).map((item, index) => (
                                    <SkeletonCard key={index} />
                                ))
                                // ) : playlistSongLibrary.length === 0 ? (
                                //     <NoResults message="No Platform Found" />
                            ) : (playlistSongLibrary && playlistSongLibrary.map((card, index) => (
                                card?.status ? <Link href={card?.streamingPlatformlink} key={index} target="_blank" style={{ textDecoration: 'none' }}>
                                    <Card
                                        sx={{
                                            cursor: 'pointer',
                                            '&:hover': { backgroundColor: '#f0f0f0' },
                                            border: '1px solid #e0e0e0',
                                            position: 'relative'
                                        }}
                                    >
                                        <CardContent sx={{ padding: 1, paddingBottom: '10px !important' }}>
                                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                                <Box display="flex" alignItems="center" gap={2}>
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: 32, height: 32, borderRadius: '50%' }}
                                                        image={getStrPlatformImg(card?.streamingPlatformKey)}
                                                    />
                                                    <Typography variant="body1" sx={{ color: '#333' }}>
                                                        {card?.streamingPlatformName}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Link>:null
                            )))}
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={8} lg={8} >
                        <PlaylistAddSong loader={loader.song} playlistData={playlistData.song} />
                    </Grid >

                </Grid >
            </Box >
        </Box >
    )
} 
